<style lang="less">
</style>

<template>
	<!-- Main form -->
	<section class="form">
		<div class="item">
			<div class="label">姓名</div>
			<div class="cont">
				<input type="text" value="" placeholder="身份证号将加密处理" />
			</div>
		</div>
		<div class="explain">请填写本人身份信息</div>
		<div class="tips">身份信息错误</div>
	</section>
</template>

<script>
	export default {
		data: function () {
			return {
			};
		},
		components: {
		},
		mounted: function () {
		},
		methods: {

		}
	};
</script>


// WEBPACK FOOTER //
// src/pages/Form.vue